import React from 'react';
import moment from 'moment';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import Button from '../../helpers/Button';

const ImageUpdate = ({ task, menuOpen, crop, feedTitle }) => {
  return (
    <div className={`flex justify-center px-4 md:px-0 mx-auto mb-10 ${menuOpen ? 'md:pl-24' : ''}`}>
      <div className="flex w-full md:w-4/5 lg:w-133">
        <span className="hidden md:block">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30" height="30">
            <path d="M400 421.3V154.7c0-23.5-19.2-42.7-42.7-42.7H90.7C67.2 112 48 131.2 48 154.7v266.7c0 23.5 19.2 42.7 42.7 42.7h266.7c23.4-.1 42.6-19.3 42.6-42.8zM157.3 304l45.3 64 66.7-96 88 128H90.7l66.6-96z" />
            <path d="M421.3 48H154.7C131.2 48 112 67.2 112 90.7V96h261.3c23.5 0 42.7 19.2 42.7 42.7V400h5.3c23.5 0 42.7-19.2 42.7-42.7V90.7c0-23.5-19.2-42.7-42.7-42.7z" />
          </svg>
        </span>
        <div className="bg-white rounded px-6 py-4 md:ml-2 lg:ml-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="hidden md:block h-16 w-16 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300 my-3">
                <img
                  src={crop.imageUrl}
                  alt={crop.name}
                  className="inline-block h-full w-full object-cover"
                />
              </div>
              <div className="ml-6">
                <h5 className="border-b-2 border-green-600 text-sm md:text-base uppercase">
                  {feedTitle}
                </h5>
                <span className="block text-sm pt-2">{moment(task.updatedAt).fromNow()}</span>
              </div>
            </div>

            <div>
              <Button
                name={task.title}
                className="text-tiny md:text-base border-2 border-cf-300 text-cf-300 rounded px-3 md:px-8 py-1 md:py-2 focus:outline-none"
              />
            </div>
          </div>
          <div className="flex flex-wrap mt-10">
            {task.album.map((url, index) => (
              <div className="w-1/3 px-2 py-2" key={index}>
                <Zoom zoomMargin={40}>
                  <img
                    src={url}
                    alt={task.title}
                    className="inline-block h-full w-full object-cover"
                  />
                </Zoom>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageUpdate;
